import { useParams } from 'react-router-dom';
import ISolvedLandingPage from './ISolvedLandingPage';

export const ISolvedPACLandingPage = () => {
  const { caseId } = useParams();

  if ( !caseId) {
    return null;
  }

  return <ISolvedLandingPage 
    caseId={caseId}
    companyId="isolved" />;
}; 